
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { useState, useEffect } from 'react';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import Home from './Pages/Home/Home';
import Menu from './Pages/Menu/Menu';
import GpExperience from './Pages/GpExperience/GpExperience';
import ScrollToTop from './components/scrolltotop';
import Html from './Pages/Html/Html';
import './App.css';

function App() {
  const [headerBg, setHeaderBg] = useState("transparent");

  return (


    <Router>
      <ScrollToTop />

      <Header background={headerBg} />
      <Routes>
      <Route path="/" element={<Home setHeaderBg={setHeaderBg} />} />
      <Route path="/foodmenu" element={<Menu setHeaderBg={setHeaderBg} />} /> 
      <Route path="/gpexperience" element={<GpExperience setHeaderBg={setHeaderBg} />} />
      <Route path="/html" element={<Html />} />
      </Routes>
      <Footer />
    </Router>
  );
}

       

    
  

export default App;
